module.exports = __webpack_public_path__ + "assets/img/sh.ab2ffe92.png";